export default __webpack_public_path__ + "static/showerHead-a25110fcefbf718245844520fe7a9ab0.png";